import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import {
    ButtonGroup,
    Button,
    LoaderMi,
    SelectControl,
    FieldsetControl,
    Row,
    Col,
    Container,
    InputControl,
} from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { getDateNaissanceInconnueFRFromYYYYMMDD } from 'components/Commun/Form/Date/dateTranformation';
import { getTelFormatWithoutSpace } from 'components/Commun/Form/maskFunctions';
import InputFiles from 'components/Commun/Form/InputFiles';
import {
    API_GET_PROFIL,
    API_MODIFIER_PERSONNE_PHYSIQUE,
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_GET_PROFIL,
    CONTEXT_MODIFIER_PERSONNE_PHYSIQUE,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import {
    formaterOptions,
    getMessageErreurChampManquant,
    getPatternHookFormValidation,
} from 'utils/utils';
import { REGEXP_EMAIL, REGEXP_NOM_PRENOM } from 'constants/contraintes.constants';
import SelectPays from 'components/form/referentiel/select/SelectPays';
import SelectDepartements from 'components/form/referentiel/select/SelectDepartement';
import { getArrayFilesToSend } from 'utils/fileFunction';
import RoutesEcranGestion from '../gestion/routes';
import { getPath } from '../../../../utils/router';
import InfoChampsObligatoire from '../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const ModifierPersonnePhysique = ({
    getApi,
    postApi,
    reinitialiseApi,
    dataCompteUsager,
    isLoadingCompteUsager,
    isLoadingModifierPersonnePhysique,
    erreurModifierPersonnePhysique,
    messageModifierPersonnePhysique,
}) => {
    const hookForm = useForm({ mode: 'onChange' });
    const { register, handleSubmit, formState, reset, watch, setError } = hookForm;
    const { isValid } = formState;
    const [dataPersonnePhysique, setDataPersonnePhysique] = useState();
    const history = useHistory();

    const choixSexe = [
        { key: 'F', value: '2', libelle: 'Féminin' },
        { key: 'M', value: '1', libelle: 'Masculin' },
    ];

    const typePieceIdentite = [
        { key: 'CNI', value: 2, libelle: "Carte nationale d'identité" },
        { key: 'passeport', value: 33, libelle: 'Passeport' },
        { key: 'titreSejour', value: 34, libelle: 'Titre de séjour' },
        { key: 'pieceIdentiteEtrangere', value: 35, libelle: 'Pièce identité étrangère' },
    ];

    const getTypePieceIdentite = (value) => {
        switch (value) {
            case 'CNI':
                return 2;
            case 'Passeport':
                return 33;
            case 'Titre de séjour':
                return 34;
            case 'Pièce identité étrangère':
                return 35;
            default:
                return null;
        }
    };

    useEffect(() => {
        if (isLoadingCompteUsager === false && dataCompteUsager) {
            const dataForm = {
                // affichage
                nom: dataCompteUsager.personnePhysique.nom,
                prenomUn: dataCompteUsager.personnePhysique.prenomUn,
                prenomDeux: dataCompteUsager.personnePhysique.prenomDeux,
                prenomTrois: dataCompteUsager.personnePhysique.prenomTrois,
                prenomQuatre: dataCompteUsager.personnePhysique.prenomQuatre,
                sexe: dataCompteUsager.personnePhysique.sexe === 'Masculin' ? '1' : '2',
                dateNaissance: getDateNaissanceInconnueFRFromYYYYMMDD(
                    dataCompteUsager.personnePhysique.dateNaissance,
                ),
                lieuNaissance: dataCompteUsager.personnePhysique.lieuNaissance,
                departementNaissance: dataCompteUsager.personnePhysique.codePostalNaissance,
                paysNaissance: dataCompteUsager.personnePhysique.paysNaissance.id,

                // champs modifiables
                nomUsage: dataCompteUsager.personnePhysique.nomUsage,
                prenomUsuel: dataCompteUsager.personnePhysique.prenomUsuel,
                nationalite: dataCompteUsager.personnePhysique.nationalite.id,
                numeroPieceIdentite:
                    dataCompteUsager?.personnePhysique?.pieceIdentite?.numeroPieceIdentite,
                typePieceIdentite: getTypePieceIdentite(
                    dataCompteUsager?.personnePhysique?.pieceIdentite?.typePieceIdentite,
                ),
                telephonePrincipal: dataCompteUsager.personnePhysique.telephonePrincipal,
                telephoneSecondaire: dataCompteUsager.personnePhysique.telephoneSecondaire,
                email: dataCompteUsager.personnePhysique.mail,
            };

            setDataPersonnePhysique({ ...dataForm });
        } else {
            setDataPersonnePhysique({});
        }
    }, [dataCompteUsager]);

    useEffect(() => {
        if (dataPersonnePhysique) {
            reset(dataPersonnePhysique);
        }
    }, [dataPersonnePhysique]);

    // on mount et unmount
    useEffect(() => {
        reinitialiseApi(CONTEXT_MODIFIER_PERSONNE_PHYSIQUE);
        getApi(
            usagerClientReducer,
            API_RECUPERER_INFORMATIONS_PERSONNELLES,
            CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
        );
        return () => {
            reinitialiseApi(CONTEXT_MODIFIER_PERSONNE_PHYSIQUE);
        };
    }, []);

    const redirectToEcranGestion = () => {
        history.push(getPath(RoutesEcranGestion));
    };

    useEffect(() => {
        if (
            !isLoadingModifierPersonnePhysique &&
            !erreurModifierPersonnePhysique &&
            messageModifierPersonnePhysique
        ) {
            getApi(usagerClientReducer, API_GET_PROFIL, CONTEXT_GET_PROFIL);
            redirectToEcranGestion();
        }
    }, [isLoadingModifierPersonnePhysique]);

    useEffect(() => {
        if (messageModifierPersonnePhysique) {
            setError('email', { type: 'manual', message: messageModifierPersonnePhysique });
        }
    }, [messageModifierPersonnePhysique]);

    const validatePrenomUsuel = (valuePrenomUsuel) => {
        if (
            valuePrenomUsuel &&
            valuePrenomUsuel !== dataPersonnePhysique.prenomUn &&
            valuePrenomUsuel !== dataPersonnePhysique.prenomDeux &&
            valuePrenomUsuel !== dataPersonnePhysique.prenomTrois &&
            valuePrenomUsuel !== dataPersonnePhysique.prenomQuatre
        ) {
            return 'Le prénom usuel doit correspondre à un des autres prénoms';
        }
        return null;
    };

    const numeroNonFrancais = (telephone) => {
        if (watch(telephone) && watch(telephone).length > 10) {
            return {
                message:
                    'Le format du numéro de téléphone ne correspond pas à un numéro de téléphone français',
            };
        }
        return null;
    };

    const prenomUsuelNonModifiable = () => {
        // le prénom usuel est non modifiable si la personne physique n'a qu'un seul prénom
        return (
            dataPersonnePhysique &&
            dataPersonnePhysique.prenomUn &&
            !dataPersonnePhysique.prenomDeux &&
            !dataPersonnePhysique.prenomTrois &&
            !dataPersonnePhysique.prenomQuatre
        );
    };

    const formaterModifications = async (dataForm) => {
        return {
            nomUsage: dataForm.nomUsage ? dataForm.nomUsage : dataPersonnePhysique.nom,
            prenomUsuel: dataForm.prenomUsuel
                ? dataForm.prenomUsuel
                : dataPersonnePhysique.prenomUn,
            idNationalite: dataForm.nationalite,
            numeroPieceIdentite: dataForm.numeroPieceIdentite,
            typePieceIdentite: dataForm.typePieceIdentite,
            piecesIdentite: dataForm.piecesIdentite
                ? await getArrayFilesToSend(dataForm.piecesIdentite)
                : null,
            telephonePrincipal: dataForm.telephonePrincipal,
            telephoneSecondaire: dataForm.telephoneSecondaire,
            email: dataForm.email,
        };
    };

    const onSubmit = async (dataForm) => {
        if (dataForm && isValid) {
            const dataFormat = await formaterModifications(dataForm);
            postApi(
                usagerClientReducer,
                API_MODIFIER_PERSONNE_PHYSIQUE,
                dataFormat,
                CONTEXT_MODIFIER_PERSONNE_PHYSIQUE,
            );
        }
    };

    return (
        <Container>
            <Row>
                <Col col={12}>
                    <h1>Modification des informations personnelles</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>
                        Vous pouvez modifier directement vos informations personnelles en saisissant
                        les informations dans les champs ci-dessous. Certaines informations
                        personnelles sont grisées car elles ne sont pas modifiables directement.
                        Pour pouvoir les modifier, veuillez en faire la demande via le formulaire de
                        contact situé en bas de l&apos;écran en cliquant sur le lien &quot;Nous
                        contacter &quot;.
                    </p>
                </Col>
            </Row>
            {(isLoadingCompteUsager || isLoadingModifierPersonnePhysique) && (
                <LoaderMi taille="md" />
            )}
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InfoChampsObligatoire />
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <SelectControl
                                id="sexe"
                                name="sexe"
                                label="Sexe"
                                options={formaterOptions(choixSexe)}
                                disabled
                                {...register('sexe')}
                                placeholder="-- Choisir une option --"
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="family-name"
                                label="Nom"
                                disabled
                                uppercase
                                {...register('nom')}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="family-name"
                                label="Nom d'usage"
                                hintText="Nom de famille utilisé dans la vie courante, à renseigner s'il ne s'agit pas du nom de naissance."
                                id="nomUsage"
                                uppercase
                                {...register('nomUsage', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        "nom d'usage",
                                    ),
                                })}
                                state={formState.errors?.nomUsage ? 'error' : null}
                                message={formState.errors?.nomUsage?.message}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <div className="sia-input-alignementSansTexteAide">
                                <InputControl
                                    autocomplete="given-name"
                                    label="Premier prénom"
                                    disabled
                                    {...register('prenomUn')}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="additional-name"
                                label="Deuxième prénom"
                                disabled
                                {...register('prenomDeux')}
                                uppercase
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="additional-name"
                                label="Troisième prénom"
                                disabled
                                {...register('prenomTrois')}
                                uppercase
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <div className="sia-input-alignementSansTexteAide">
                                <InputControl
                                    autocomplete="additional-name"
                                    label="Quatrième prénom"
                                    disabled
                                    {...register('prenomQuatre')}
                                    uppercase
                                />
                            </div>
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="given-name"
                                label="Prénom usuel"
                                disabled={prenomUsuelNonModifiable()}
                                hintText="Prénom utilisé dans la vie courante, il doit être identique à l'un des prénoms renseignés dans le formulaire."
                                {...register('prenomUsuel', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        'prénom usuel',
                                    ),
                                    validate: (value) => validatePrenomUsuel(value),
                                })}
                                uppercase
                                state={formState.errors?.prenomUsuel ? 'error' : null}
                                message={formState.errors?.prenomUsuel?.message}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="bday"
                                label="Date de naissance"
                                disabled
                                {...register('dateNaissance')}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <SelectPays
                                name="paysNaissance"
                                label="Pays de naissance"
                                disabled
                                register={register('paysNaissance')}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <SelectDepartements
                                name="departementNaissance"
                                label="Département de naissance"
                                disabled
                                register={register('departementNaissance')}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="street-address"
                                label="Lieu de naissance"
                                disabled
                                uppercase
                                {...register('lieuNaissance')}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <SelectPays
                                name="nationalite"
                                id="nationalite"
                                label="Nationalité *"
                                required
                                placeholder="-- Choisir une option --"
                                register={register('nationalite', {
                                    required: getMessageErreurChampManquant('nationalité'),
                                })}
                            />
                        </Col>
                    </Row>
                    <div className="margin-top-md">
                        <FieldsetControl
                            id="pieceIdentite"
                            legend="Pièce d'identité"
                            hintText="Pour des raisons de sécurité informatique, votre pièce
                                d'identité ne peut pas être visualisée depuis votre
                                espace personnel. En cas de doute, vous pouvez téléverser une nouvelle fois votre pièce d'identité."
                        >
                            <Row gutters horizontalAlign="center" verticalAlign="bottom">
                                <Col col={12} lg={6}>
                                    <div className="sia-input-alignementSansTexteAide">
                                        <SelectControl
                                            id="typePieceIndentite"
                                            name="typePieceIndentite"
                                            label="Sélectionnez votre type de pièce d'identité *"
                                            options={formaterOptions(typePieceIdentite)}
                                            required
                                            {...register('typePieceIdentite', {
                                                required: getMessageErreurChampManquant(
                                                    "type de pièce d'identité",
                                                ),
                                            })}
                                            placeholder="-- Choisir une option --"
                                        />
                                    </div>
                                </Col>
                                <Col col={12} lg={6}>
                                    <InputControl
                                        id="numeroPieceIdentite"
                                        label="Numéro de la pièce d'identité *"
                                        required
                                        {...register('numeroPieceIdentite', {
                                            required: getMessageErreurChampManquant(
                                                "numéro de la pièce d'identité",
                                            ),
                                        })}
                                        state={
                                            formState.errors?.numeroPieceIdentite ? 'error' : null
                                        }
                                        message={formState.errors?.numeroPieceIdentite?.message}
                                    />
                                </Col>
                            </Row>
                            <Row gutters>
                                <Col col={12} lg={6}>
                                    <InputFiles
                                        name="piecesIdentite"
                                        label="Si vous souhaitez changer votre pièce d'identité, veuillez en importer une nouvelle en cliquant sur le bouton ci-dessous"
                                        error={
                                            formState.errors
                                                ? formState.errors.piecesIdentite
                                                : null
                                        }
                                        multiple
                                        {...register('piecesIdentite')}
                                    />
                                </Col>
                            </Row>
                        </FieldsetControl>
                    </div>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="tel-national"
                                id="telephonePrincipal"
                                label="Téléphone 1 *"
                                uppercase
                                required
                                maxLength="60"
                                {...register('telephonePrincipal', {
                                    required: getMessageErreurChampManquant('Téléphone'),
                                })}
                                state={formState.errors?.telephonePrincipal ? 'error' : null}
                                message={formState.errors?.telephonePrincipal?.message}
                                placeholder="Exemple: 0612345678"
                                warning={numeroNonFrancais('telephonePrincipal')}
                                maskFonction={getTelFormatWithoutSpace}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="tel-national"
                                id="telephoneSecondaire"
                                label="Téléphone 2"
                                uppercase
                                maxLength="60"
                                {...register('telephoneSecondaire')}
                                placeholder="Exemple: 0198765432"
                                warning={numeroNonFrancais('telephoneSecondaire')}
                                maskFonction={getTelFormatWithoutSpace}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="email"
                                id="email"
                                label="E-mail *"
                                required
                                {...register('email', {
                                    required: getMessageErreurChampManquant('E-mail'),
                                    pattern: {
                                        value: REGEXP_EMAIL,
                                        message: "Le format de l'adresse mail n'est pas valide",
                                    },
                                })}
                                state={formState.errors?.email ? 'error' : null}
                                message={formState.errors?.email?.message}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <ButtonGroup align="right" inline>
                                <Button
                                    name="retour"
                                    variant="secondary"
                                    onClick={redirectToEcranGestion}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="valider"
                                    variant="primary"
                                    type="submit"
                                    disabled={!isValid}
                                >
                                    Enregistrer les modifications
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </Container>
    );
};

ModifierPersonnePhysique.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataCompteUsager: PropTypes.shape({
        personnePhysique: PropTypes.shape({
            nom: PropTypes.string.isRequired,
            nomUsage: PropTypes.string.isRequired,
            prenomUn: PropTypes.string.isRequired,
            prenomDeux: PropTypes.string,
            prenomTrois: PropTypes.string,
            prenomQuatre: PropTypes.string,
            prenomUsuel: PropTypes.string.isRequired,
            sexe: PropTypes.string,
            dateNaissance: PropTypes.string,
            lieuNaissance: PropTypes.string,
            codePostalNaissance: PropTypes.string,
            paysNaissance: PropTypes.shape({
                id: PropTypes.string.isRequired,
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            nationalite: PropTypes.shape({
                id: PropTypes.string.isRequired,
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            adressePrincipale: PropTypes.shape({
                numeroVoie: PropTypes.string,
                extension: PropTypes.string,
                libelleVoie: PropTypes.string,
                lieuDit: PropTypes.string,
                codePostal: PropTypes.string,
                ville: PropTypes.string,
                pays: PropTypes.shape({
                    libelle: PropTypes.string.isRequired,
                }).isRequired,
                justificatifsDomicile: PropTypes.shape({
                    fichiers: PropTypes.arrayOf({
                        uuid: PropTypes.string.isRequired,
                        filename: PropTypes.string.isRequired,
                    }),
                }),
            }).isRequired,
            pieceIdentite: PropTypes.shape({
                numeroPieceIdentite: PropTypes.string,
                typePieceIdentite: PropTypes.string,
            }),
            telephonePrincipal: PropTypes.string.isRequired,
            telephoneSecondaire: PropTypes.string,
            mail: PropTypes.string.isRequired,
        }).isRequired,
    }),
    isLoadingCompteUsager: PropTypes.bool,
    isLoadingModifierPersonnePhysique: PropTypes.bool,
    erreurModifierPersonnePhysique: PropTypes.bool,
    messageModifierPersonnePhysique: PropTypes.string,
};

export default connect(
    (state) => {
        const { isLoading: isLoadingCompteUsager, data: dataCompteUsager } =
            state.monCompte.recupererInformationsPersonnelles;
        const {
            isLoading: isLoadingModifierPersonnePhysique,
            erreur: erreurModifierPersonnePhysique,
            message: messageModifierPersonnePhysique,
        } = state.monCompte.modifierPersonnePhysique;
        return {
            dataCompteUsager,
            isLoadingCompteUsager,
            isLoadingModifierPersonnePhysique,
            erreurModifierPersonnePhysique,
            messageModifierPersonnePhysique,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ModifierPersonnePhysique);
